import { render } from "./pointsItem.vue?vue&type=template&id=d81fee3a&scoped=true"
import script from "./pointsItem.vue?vue&type=script&lang=js"
export * from "./pointsItem.vue?vue&type=script&lang=js"

import "./pointsItem.vue?vue&type=style&index=0&id=d81fee3a&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81fee3a"]])

export default __exports__